import { useState, useEffect } from 'react';
import { QUALITY_SERVICE_API_URL } from '../config';

const useQuarantinedTestsHistory = (selectedUnit = 'All units') => {
    const [chartData, setChartData] = useState({ dates: [], counts: [], rawData: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchQuarantineHistory = async () => {
            try {
                const response = await fetch(`${QUALITY_SERVICE_API_URL}/quarantine/history`, {
                    headers: { 'accept': '*/*' }
                });
                const data = await response.json();
                
                const dates = data.reverse().map(item => {
                    const date = new Date(item.date);
                    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                });
                
                const counts = data.map(item => {
                    if (selectedUnit === 'All units') {
                        return item.error_and_surveys + item.screen_insights + item.session_replay;
                    }
                    return item[selectedUnit] || 0;
                });
                
                setChartData({ dates, counts, rawData: data });
                setLoading(false);
            } catch (error) {
                console.error('Error fetching quarantine history:', error);
                setLoading(false);
            }
        };

        fetchQuarantineHistory();
    }, [selectedUnit]);

    return { chartData, loading };
};

export default useQuarantinedTestsHistory;
